import React from 'react';
import { Button } from 'react-bootstrap'
import { Plus as Icon } from 'react-bootstrap-icons'
import useAddButton from './use-add-button';

export default ({ visible }) => {
    const { isCreatePermitted, createCourse } = useAddButton();
    if (!isCreatePermitted || !visible) {
        return null;
    }

    return (
        <Button
            variant="outline-primary"
            onClick={createCourse}
            title='Create New Experience'
        >
            <Icon size={25} />
        </Button>
    );
};
